import { BASE_API_URL_CAP_DIEN } from "@utils/constants";

export const APIVatTuLienSo = {
  LIST_VAT_TU_LIEN_SO: `${BASE_API_URL_CAP_DIEN}/vat-tu-lien-so/list`,
  SYNC_VAT_TU_LIEN_SO: `${BASE_API_URL_CAP_DIEN}/vat-tu-lien-so/sync`,
};
